<template>
  <popup class="global-step-select-popup" @close="$emit('close')">
    <div slot="popupMainContent">
      <div class="layout-apply-header mb-3">
        <layout-miniature :layout="layout" class="mr-3" />
        <div>
          <label class="vform-editor-button-text">Apply Layout</label>
          <span class="layout-apply-name ml-2">{{ layout.name }}</span><br>
          <label class="vform-editor-button-text info-label mt-1">Select steps to apply this layout to</label>
        </div>
      </div>
      <div class="d-flex fancy-scrollbar multi-select">
        <div
          v-for="(step, index) in steps"
          :key="step.uuid"
          :class="['pl-2 pr-2 multi-select-item clickable', isSelected(step) ? 'selected' : '', index % 2 === 0 ? 'even' : 'odd']"
          @click="toggleStep(step, index, $event)"
        >
          {{ `Step ${index + 1} - ${step.name}` }}
        </div>
      </div>
      <label class="vform-editor-button-text info-label text-notransform clickable mt-2">
        Press SHIFT between two selections to define a range
      </label>
      <div class="mt-2">
        <div class="clickable settings-button d-inline-block mr-3" @click="selectAll">Select All</div>
        <div class="clickable settings-button d-inline-block mr-3" @click="unselectAll">Unselect All</div>
        <div class="clickable settings-button d-inline-block" @click="applyToSelected">Apply</div>
      </div>
    </div>
  </popup>
</template>
<script>
import Popup from "@/components/Popup.vue";
import LayoutMiniature from "@/components/vForm/layout/LayoutMiniature.vue";
export default {
  name: "LayoutApplyToStepsPopup",
  components: { Popup, LayoutMiniature },
  props: {
    steps: { type: Array, required: true },
    layout: { type: Object, required: true },
    preSelectedStepUuid: { type: String, default: null },
  },
  data() {
    return {
      selectedUuids: [],
      lastClickedIndex: -1,
    };
  },
  mounted() {
    if (this.preSelectedStepUuid) {
      this.selectedUuids = [this.preSelectedStepUuid];
    }
  },
  methods: {
    isSelected(step) {
      return this.selectedUuids.includes(step.uuid);
    },
    toggleStep(step, index, event) {
      if (event.shiftKey && this.lastClickedIndex !== -1) {
        const from = Math.min(this.lastClickedIndex, index);
        const to = Math.max(this.lastClickedIndex, index);
        for (let i = from; i <= to; i++) {
          const uuid = this.steps[i].uuid;
          if (!this.selectedUuids.includes(uuid)) {
            this.selectedUuids.push(uuid);
          }
        }
      } else {
        const idx = this.selectedUuids.indexOf(step.uuid);
        if (idx === -1) {
          this.selectedUuids.push(step.uuid);
        } else {
          this.selectedUuids.splice(idx, 1);
        }
      }
      this.lastClickedIndex = index;
    },
    selectAll() {
      this.selectedUuids = this.steps.map((s) => s.uuid);
    },
    unselectAll() {
      this.selectedUuids = [];
    },
    applyToSelected() {
      this.$emit("apply", this.selectedUuids);
    },
  },
};
</script>
<!-- Match the popup background used by the global-panel step-select popup -->
<style lang="scss">
.global-step-select-popup {
  .popup {
    background-color: var(--vform-editor-layout-tertiary-color);
  }
}
</style>

<style lang="scss" scoped>
.layout-apply-header {
  display: flex;
  align-items: center;
}

.layout-apply-name {
  font-size: 0.9rem;
  opacity: 0.7;
}

.multi-select {
  flex-direction: column;
  max-height: 300px;
  overflow-x: hidden;
  overflow-y: auto;
  border: solid 1px var(--vform-editor-ui-quaternary-color);
}

.multi-select-item {
  min-width: 50px;
  background-color: var(--vform-editor-ui-secondary-color);
  padding: 4px;
  display: inline-flex;
  width: 99%;
  color: white;
  justify-content: start;
  user-select: none;

  &:hover {
    background-color: var(--vform-editor-ui-quinary-color) !important;
  }

  &.selected {
    background-color: var(--vform-editor-accent-color);

    &:hover {
      background-color: var(--vform-editor-accent-color-hover) !important;
    }
  }

  &.odd {
    background-color: var(--vform-editor-ui-secondary-color);

    &.selected {
      background-color: var(--vform-editor-accent-color);
    }
  }

  &.even {
    background-color: var(--vform-editor-layout-tertiary-color);

    &.selected {
      background-color: var(--vform-editor-accent-color-hover);
    }
  }
}

.info-label {
  color: var(--vform-editor-ui-tertiary-color);
  font-size: 0.75rem !important;
}

.text-notransform {
  text-transform: revert !important;
}
</style>
